/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyMonitoredObjecForBackendApiActualvehicleStateApi
 */
export interface ReadOnlyMonitoredObjecForBackendApiActualvehicleStateApi {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjecForBackendApiActualvehicleStateApi
     */
    readonly id?: number;
}

export function ReadOnlyMonitoredObjecForBackendApiActualvehicleStateApiFromJSON(json: any): ReadOnlyMonitoredObjecForBackendApiActualvehicleStateApi {
    return ReadOnlyMonitoredObjecForBackendApiActualvehicleStateApiFromJSONTyped(json, false);
}

export function ReadOnlyMonitoredObjecForBackendApiActualvehicleStateApiFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyMonitoredObjecForBackendApiActualvehicleStateApi {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function ReadOnlyMonitoredObjecForBackendApiActualvehicleStateApiToJSON(value?: ReadOnlyMonitoredObjecForBackendApiActualvehicleStateApi | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


